import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import UserContext from "../../context/user";
import CartContext from "../../context/cart";
import CartCard from "./cart-card";
import { translateCart } from "../../utils/lang";
import AppError from "../app-error";

const CartSelectionChoice = ({ cartRequestMutation, handleCartSelection }) => {
  const { logged, callApi } = useContext(UserContext);
  const { appLang, labels } = useContext(CartContext);

  const {
    isFetching,
    error,
    data: carts,
  } = useQuery(["carts"], () => callApi("/cart/search?offset=0&limit=30", { method: "POST" }), {
    enabled: logged,
    select: (data) => data?.list?.map((cart) => translateCart(cart, appLang)),
  });

  return error ? (
    <AppError labels={labels} />
  ) : isFetching ? (
    <div className="loading-spinner mt" />
  ) : (
    <>
      {carts?.length === 0 ? (
        <div>No carts were found</div>
      ) : (
        <div className="carrello-content__card-wrapper">
          {carts.map((item) => (
            <CartCard
              key={item?.id}
              item={item}
              cartRequestMutation={cartRequestMutation}
              handleCartSelection={handleCartSelection}
            />
          ))}
        </div>
      )}
      {cartRequestMutation?.isError && <div className="error">Error creating cart request</div>}
    </>
  );
};

export default CartSelectionChoice;
